import React from "react";
import { ChatConversation } from "../../../types";
import { ItemContainer, ItemTitle, ItemSubtitle } from "./styled";

export interface HistoryItemProps {
  conversation: ChatConversation;
  subtitle: string;
  onClick: () => void;
}

export default function HistoryItem({ conversation, subtitle, onClick }: HistoryItemProps) {
  return (
    <ItemContainer onClick={onClick}>
      <ItemTitle>{conversation.title}</ItemTitle>
      <ItemSubtitle>{subtitle}</ItemSubtitle>
    </ItemContainer>
  );
}
